import { Strategy } from 'utility-ts-strategy';
import { IBusyTimeError } from '../interfaces/busy_time_interface';

export let BusyTimeErrorMessage = new Strategy<IBusyTimeError>({
  isAnyPropertyNotSet: {
    message: `Please enter a complete [start/end] time`
  },
  isStartTimeAfterEnd: {
    message: `Start time should occur before end time`
  },
  isOutOfTimeWindow: {
    message: `One or both times are outside of time window`
  },
  isTimeOverlap: {
    message: `There is a conflict at this time`
  },
  invalidCharsInHour: {
    message: `Enter a number between 1-12 in the hours field`
  },
  invalidCharsInMinutes: {
    message: `Enter a number between 00-59 in the minutes field`
  },
  invalidCharsInPeriod: {
    message: `Enter AM or PM for your time block`
  }
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/strategies/busy_time_strategy.ts